import { Component, OnInit } from "@angular/core";
import { IVTableRow } from "@app/directives/_layout/v-table/_models/IVTableRow";
import { IVehicle } from "@interfaces/IVehicle";
import { VehicleService } from "@services/vehicle.service";
import "./vehicles.component.scss";

@Component({
    selector: "vehicles-page",
    template: require("./vehicles.component.html")
})
export class VehiclesPageRouteComponent implements OnInit {

    loading = false;
    vehicles: IVehicle[] = [];
    selectedVehicle: IVehicle;

    constructor(private readonly vehicleService: VehicleService) {

    }

    ngOnInit() {
        this.getData();
    }

    onRowClicked($event: IVTableRow) {
        this.selectedVehicle = $event.data;
        console.log(this.selectedVehicle);
    }

    // ---

    maxTempColumns = 0;

    private getData() {
        this.loading = true;

        this.vehicleService.getVehicles({ includeLatestPlots: true, includeLatestTemp: true, includePeripheralMappings: true })
            .then(vehicles => {
                this.vehicles = vehicles;

                const vehiclesWithTemp = this.vehicles.filter(v => v.Temperatures?.length != 0);
                vehiclesWithTemp.forEach(v => {
                    this.maxTempColumns = Math.max(this.maxTempColumns, v.Temperatures.length);
                });

            })
            .finally(() => {
                this.loading = false;
            });
    }
}
